export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement en cours..."])}
      },
      "en": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])}
      }
    }
  })
}
